import React from "react";

import { Divider, Tab, Tabs } from "@mui/material";

interface Props {
  graphKeys: string[];
  value: string;
  handleChange: (event: React.SyntheticEvent, newValue: string) => void;
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`
  };
}

export const GraphTabs: React.FC<Props> = ({ value, handleChange, graphKeys }) => {
  const graphKeysWithDividers = graphKeys.reduce<Array<string | null>>((acc, key, index, arr) => {
    return [...acc, key, ...(index !== arr.length - 1 ? [null] : [])];
  }, []);

  return (
    <Tabs
      value={value}
      onChange={(...all) => {
        handleChange(...all);
      }}
      aria-label="basic tabs example"
      sx={{
        minHeight: "unset",
        "& .MuiTabs-flexContainer": {
          gap: "16px",
          alignItems: "center"
        },
        "& .MuiTabs-indicator": {
          minWidth: "40px"
          // width: "100% !important"
        },
        "& .MuiTab-root": {
          fontSize: "14px",
          lineHeight: "16px",
          fontWeight: 500,
          color: "#496682",
          minHeight: "unset",
          padding: "0 0 6px 0",
          minWidth: "40px",
          width: "auto"
        }
      }}
    >
      {graphKeysWithDividers.map((item, index) => {
        if (item === null) {
          return <Divider orientation="vertical" sx={{ height: "16px", borderColor: "#DBE8F5" }} key={index} />;
        }
        return <Tab label={item} value={item} {...a11yProps(index)} key={item} />;
      })}
    </Tabs>
  );
};
